import { Rating } from 'office-ui-fabric-react/lib/Rating';
import {Stack} from 'office-ui-fabric-react/lib/Stack';
import * as React from 'react';
// tslint:disable-next-line:no-duplicate-imports
import { useState } from 'react';

import { Review } from '../../store';
import * as houzzReviews from '../../store/houzz-reviews.json';
import { reviewThumbnails } from '../review/review';
import { Thumbnail } from '../thumbnailImage';
import classNames from './reviewList.classNames';

export interface ReviewListAttributes {
    reviews: Review[];
}

export interface ReviewListActions {
    fetch(done: () => void): void;
}

export type ReviewListProps = ReviewListAttributes & ReviewListActions;

type HouzzReview = {
    date: string;
    text: string;
};

enum Months {
 January,
 February,
 March,
 April,
 May,
 June,
 July,
 August,
 September,
 October,
 November,
 December
}

const shortDate = (utc: string) => {
    const utcDate = new Date(`${utc}Z`);

    return `${Months[utcDate.getMonth()]} ${utcDate.getFullYear()}`;
};

const renderAuthor = (review: Review) => review.author ? <p>by {review.author}</p> : null;

const renderReview = (review: Review) => (
    <div key={`review_${review.requestId}`}>
        <p>{shortDate(review.createdOnUtc)}</p>
        {renderAuthor(review)}
        <Rating
            min={0}
            max={5}
            rating={review.rating}
            readOnly={true}
            styles={{ratingStarFront: { color: 'gold'}}}
        />
        <p>{review.comment}</p>
        <div className={classNames().photos}>
            {reviewThumbnails(review).map((thumbnailProps, i) => <Thumbnail {...thumbnailProps} key={`thumb_${i}`}/>)}
        </div>
    </div>);

const renderHouzzReview = (review: HouzzReview, index: number) => (
    <div key={`houzz_review_${index}`}>
        <p>{review.date}</p>
        <Rating
            min={0}
            max={5}
            rating={5}
            readOnly={true}
            styles={{ratingStarFront: { color: 'gold'}}}
        />
        <p>{review.text}</p>
    </div>
);
export const ReviewList = (props: ReviewListProps) => {
    const [state, setState] = useState<'loading' | 'loaded'>('loading');

    React.useEffect(() => {
        if (state === 'loading') {
            props.fetch(() => {
                setState('loaded');
            });
        }
    });

    return (
        <Stack className={classNames().stack}>
            {props.reviews.map(renderReview)}
            {houzzReviews.map(renderHouzzReview)}
        </Stack>);
};
